import { nonEmpty, object, pipe, string } from 'valibot';

export const loginFormSchema = object({
    email: pipe(string(), nonEmpty()),
    password: pipe(string(), nonEmpty())
});
